
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/entrar",
      function () {
        return require("private-next-pages/business/entrar/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/entrar"])
      });
    }
  